import {
  Grid,
  GridItem,
  Text,
  VStack,
  HStack,
  Checkbox,
} from '@chakra-ui/react';

import { ValidatedField, CurrencyInput } from '..';
import type { CoverageSectionProps } from './types';

const LegalCoveragesSection = ({
  coverages,
  updateCoverage,
}: CoverageSectionProps) => {
  const coveragesEntity = { coverages } as unknown as Record<string, unknown>;

  return (
    <Grid templateColumns="1fr 1fr" gap={4}>
      <GridItem>
        <Text fontWeight="700" mb={3}>
          Legal Coverages
        </Text>
        <VStack align="stretch" spacing={3}>
          <HStack spacing={3} align="flex-end">
            <Checkbox
              isChecked={coverages.bylaw_enabled}
              onChange={(e) =>
                updateCoverage('bylaw_enabled', e.target.checked)
              }
              colorScheme="blue"
            >
              <Text fontSize="sm">By-Laws</Text>
            </Checkbox>
            <ValidatedField
              itemPath="location/coverages"
              fieldPath="coverages.bylaw_limit_cad"
              label="Limit"
              labelSize="xs"
              entity={coveragesEntity}
              isDisabled={!coverages.bylaw_enabled}
              formControlProps={{ w: '90px' }}
            >
              <CurrencyInput
                value={coverages.bylaw_limit_cad ?? ''}
                onChange={(_, value) =>
                  updateCoverage('bylaw_limit_cad', value)
                }
                placeholder={coverages.bylaw_enabled ? 'BASE' : ''}
                isDisabled={!coverages.bylaw_enabled}
              />
            </ValidatedField>
            <ValidatedField
              itemPath="location/coverages"
              fieldPath="coverages.bylaw_deductible_cad"
              label="Deductible"
              labelSize="xs"
              entity={coveragesEntity}
              isDisabled={!coverages.bylaw_enabled}
              formControlProps={{ w: '90px' }}
            >
              <CurrencyInput
                value={coverages.bylaw_deductible_cad ?? ''}
                onChange={(_, value) =>
                  updateCoverage('bylaw_deductible_cad', value)
                }
                placeholder={coverages.bylaw_enabled ? 'BASE' : ''}
                isDisabled={!coverages.bylaw_enabled}
              />
            </ValidatedField>
          </HStack>
          <HStack spacing={3} align="flex-end">
            <Checkbox
              isChecked={coverages.fire_department_enabled}
              onChange={(e) =>
                updateCoverage('fire_department_enabled', e.target.checked)
              }
              colorScheme="blue"
            >
              <Text fontSize="sm">Fire Department</Text>
            </Checkbox>
            <ValidatedField
              itemPath="location/coverages"
              fieldPath="coverages.fire_department_limit_cad"
              label="Limit"
              labelSize="xs"
              entity={coveragesEntity}
              isDisabled={!coverages.fire_department_enabled}
              formControlProps={{ w: '90px' }}
            >
              <CurrencyInput
                value={coverages.fire_department_limit_cad ?? ''}
                onChange={(_, value) =>
                  updateCoverage('fire_department_limit_cad', value)
                }
                placeholder={coverages.fire_department_enabled ? 'BASE' : ''}
                isDisabled={!coverages.fire_department_enabled}
              />
            </ValidatedField>
            <ValidatedField
              itemPath="location/coverages"
              fieldPath="coverages.fire_department_deductible_cad"
              label="Deductible"
              labelSize="xs"
              entity={coveragesEntity}
              isDisabled={!coverages.fire_department_enabled}
              formControlProps={{ w: '90px' }}
            >
              <CurrencyInput
                value={coverages.fire_department_deductible_cad ?? ''}
                onChange={(_, value) =>
                  updateCoverage('fire_department_deductible_cad', value)
                }
                placeholder={coverages.fire_department_enabled ? 'BASE' : ''}
                isDisabled={!coverages.fire_department_enabled}
              />
            </ValidatedField>
          </HStack>
          <HStack spacing={3} align="flex-end">
            <Checkbox
              isChecked={coverages.identity_theft_enabled}
              onChange={(e) =>
                updateCoverage('identity_theft_enabled', e.target.checked)
              }
              colorScheme="blue"
            >
              <Text fontSize="sm">Identity Theft</Text>
            </Checkbox>
            <ValidatedField
              itemPath="location/coverages"
              fieldPath="coverages.identity_theft_limit_cad"
              label="Limit"
              labelSize="xs"
              entity={coveragesEntity}
              isDisabled={!coverages.identity_theft_enabled}
              formControlProps={{ w: '90px' }}
            >
              <CurrencyInput
                value={coverages.identity_theft_limit_cad ?? ''}
                onChange={(_, value) =>
                  updateCoverage('identity_theft_limit_cad', value)
                }
                placeholder={coverages.identity_theft_enabled ? 'BASE' : ''}
                isDisabled={!coverages.identity_theft_enabled}
              />
            </ValidatedField>
            <ValidatedField
              itemPath="location/coverages"
              fieldPath="coverages.identity_theft_deductible_cad"
              label="Deductible"
              labelSize="xs"
              entity={coveragesEntity}
              isDisabled={!coverages.identity_theft_enabled}
              formControlProps={{ w: '90px' }}
            >
              <CurrencyInput
                value={coverages.identity_theft_deductible_cad ?? ''}
                onChange={(_, value) =>
                  updateCoverage('identity_theft_deductible_cad', value)
                }
                placeholder={coverages.identity_theft_enabled ? 'BASE' : ''}
                isDisabled={!coverages.identity_theft_enabled}
              />
            </ValidatedField>
          </HStack>
        </VStack>
      </GridItem>
      <GridItem>
        <VStack align="stretch" spacing={3} mt={8}>
          <HStack spacing={3} align="flex-end">
            <Checkbox
              isChecked={coverages.personal_cyber_enabled}
              onChange={(e) =>
                updateCoverage('personal_cyber_enabled', e.target.checked)
              }
              colorScheme="blue"
            >
              <Text fontSize="sm">Personal Cyber</Text>
            </Checkbox>
            <ValidatedField
              itemPath="location/coverages"
              fieldPath="coverages.personal_cyber_limit_cad"
              label="Limit"
              labelSize="xs"
              entity={coveragesEntity}
              isDisabled={!coverages.personal_cyber_enabled}
              formControlProps={{ w: '100px' }}
            >
              <CurrencyInput
                value={coverages.personal_cyber_limit_cad ?? ''}
                onChange={(_, value) =>
                  updateCoverage('personal_cyber_limit_cad', value)
                }
                placeholder={coverages.personal_cyber_enabled ? 'BASE' : ''}
                isDisabled={!coverages.personal_cyber_enabled}
              />
            </ValidatedField>
            <ValidatedField
              itemPath="location/coverages"
              fieldPath="coverages.personal_cyber_deductible_cad"
              label="Deductible"
              labelSize="xs"
              entity={coveragesEntity}
              isDisabled={!coverages.personal_cyber_enabled}
              formControlProps={{ w: '100px' }}
            >
              <CurrencyInput
                value={coverages.personal_cyber_deductible_cad ?? ''}
                onChange={(_, value) =>
                  updateCoverage('personal_cyber_deductible_cad', value)
                }
                placeholder={coverages.personal_cyber_enabled ? 'BASE' : ''}
                isDisabled={!coverages.personal_cyber_enabled}
              />
            </ValidatedField>
          </HStack>
          <HStack spacing={3} align="flex-end">
            <Checkbox
              isChecked={coverages.rental_income_enabled}
              onChange={(e) =>
                updateCoverage('rental_income_enabled', e.target.checked)
              }
              colorScheme="blue"
            >
              <Text fontSize="sm">Rental Income</Text>
            </Checkbox>
            <ValidatedField
              itemPath="location/coverages"
              fieldPath="coverages.rental_income_limit_cad"
              label="Limit"
              labelSize="xs"
              entity={coveragesEntity}
              isDisabled={!coverages.rental_income_enabled}
              formControlProps={{ w: '100px' }}
            >
              <CurrencyInput
                value={coverages.rental_income_limit_cad ?? ''}
                onChange={(_, value) =>
                  updateCoverage('rental_income_limit_cad', value)
                }
                placeholder={coverages.rental_income_enabled ? 'BASE' : ''}
                isDisabled={!coverages.rental_income_enabled}
              />
            </ValidatedField>
            <ValidatedField
              itemPath="location/coverages"
              fieldPath="coverages.rental_income_deductible_cad"
              label="Deductible"
              labelSize="xs"
              entity={coveragesEntity}
              isDisabled={!coverages.rental_income_enabled}
              formControlProps={{ w: '100px' }}
            >
              <CurrencyInput
                value={coverages.rental_income_deductible_cad ?? ''}
                onChange={(_, value) =>
                  updateCoverage('rental_income_deductible_cad', value)
                }
                placeholder={coverages.rental_income_enabled ? 'BASE' : ''}
                isDisabled={!coverages.rental_income_enabled}
              />
            </ValidatedField>
          </HStack>
        </VStack>
      </GridItem>
    </Grid>
  );
};

export default LegalCoveragesSection;
